export default function CollapseOne() {
    return (
        <div className="flex flex-col my-2 gap-4">
            <p>           No debe administrarse a pacientes con hipertonía del parasimpático
            </p>
        </div>
    )
        ;
}